'use strict';

require('./plugins/storelocator/jquery.storelocator');
var processInclude = require('./util');

$(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/wishlistHeart'));
    processInclude(require('./product/storeExclusivity'));
    processInclude(require('./product/quickViewDetail'));
    processInclude(require('./checkout/shipping/inStoreDrawer'));
});
